import React, { useState, useEffect } from "react";
import "./ImportFromExcel.css";
import Swal from "sweetalert2";
import axios from "axios";
const ImportFromExcel = ({ onFileUpload, Ip }) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [adminUsername, setAdminUsername] = useState("");
  const [access_role, setAccessRole] = useState("");

  useEffect(() => {
    const storedAdmin = localStorage.getItem("admin_info");
    const admin = storedAdmin ? JSON.parse(storedAdmin) : null;
    if (admin) {
      setAccessRole(Number(admin.accessLvl));
      setAdminUsername(admin.username);
    }
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setMessage("Please select a valid Excel file (.xls or .xlsx)");
      e.target.value = null;
      return;
    }

    setFile(selectedFile);
    setMessage("");
    if (onFileUpload) onFileUpload(selectedFile);
  };

  const handleSubmit = async () => {
    if (!file) {
      setMessage("No file selected!");
      return;
    }
    const formData = new FormData();
    formData.append("admin", adminUsername);
    formData.append("excel_file", file);
    try {
      const res = await axios.post(
        `${Ip}/Dashboard/import_from_excel.php`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        },
      );

      if (res.data.success) {
        Swal.fire("Added!", res.data.message, "success");
        setFile(null);
      } else {
        Swal.fire("Error", "Add failed.", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };

  return (
    <div className="import-page">
      <div className="import-container">
        <h2>Import Excel File</h2>
        <p className="subtitle">
          Upload an Excel file (.xls or .xlsx) to import your data.
        </p>

        <label className="file-upload">
          <input type="file" accept=".xls,.xlsx" onChange={handleFileChange} />
          <span>{file ? file.name : "Click to select Excel file"}</span>
        </label>

        {message && <p className={file ? "success" : "error"}>{message}</p>}

        <button onClick={handleSubmit}>Import File</button>
      </div>
    </div>
  );
};

export default ImportFromExcel;
